export class SharememberInviteData {
    permissions: string[];
    emails: string[];
    privateMessage?: string;
    displayName: string;
}

